import styles from "../../SettingsPaymentDetails.module.scss";
import { usePaymentDetails } from "../../hooks/usePaymentDetails";
import { useTranslation } from "next-i18next";

export const PaymentDetailsText = () => {
  const { t } = useTranslation("translations");
  const { paymentDetails } = usePaymentDetails();

  const paymentType = t("web_payment_current_payment_type");
  const variant = paymentDetails?.Variant || "**";
  const lastCardDigits = paymentDetails?.LastCardDigits || "**";

  return (
    <p className={styles.PaymentDetailsText}>
      <span className={styles.PaymentType}>{`${paymentType}:`}</span>
      {` `}
      <span>{variant}</span>
      {`, `}
      <span>{lastCardDigits}</span>
    </p>
  );
};
